import React from 'react';
import './global.css';

const FOOTER_ITEMS = [
    { key: 'Home',          href: '/record-phone-calls-on-iphone-or-android',                                    label: 'Home'          },
    { key: 'UserGuide',     href: '/call-recorder-and-transcriber-user-guide',                                   label: 'Tutorial'      },
    { key: 'Pricing',       href: '/how-much-does-it-cost-to-record-and-transcribe-phone-call-conversation',     label: 'Pricing'       },
    { key: 'TermsOfUse',    href: '/call-recorder-and-transcriber-terms-of-use',                                 label: 'Terms of Use'  },
    { key: 'PrivacyPolicy', href: '/call-recorder-and-transcriber-privacy-policy',                               label: 'Privacy Policy'},
    { key: 'FAQ',           href: '/call-recorder-and-transcriber-frequently-asked-questions',                   label: 'FAQ'           },
    { key: 'ContactUs',     href: '/answer-solutions-contact',                                                   label: 'Support'       },
    { key: 'About',         href: '/about-answer-solutions',                                                     label: 'About'         },
];

function PageFooter({ navigate, current }) {
    return (
        <div className="card" id="shellPrimaryNoPadding">
            <div className="fast_nav containerNoMargin">
                <ul>
                    <li className="first">
                        <a href="https://answersolutions.net" target="_blank" rel="noopener noreferrer">
                            {new Date().getFullYear()} &copy; AnswerSolutions LLC
                        </a>
                    </li>
                    {FOOTER_ITEMS.map(item => (
                        <li key={item.key} className={current === item.key ? 'current' : ''}>
                            <a href={item.href} role="button" onClick={() => navigate(item.key)}>{item.label}</a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
}

export default PageFooter;
